export default "__VITE_ASSET__7296c16b__"